import { useState } from "react";

export function SelectOption( { onClick, selected = false, children }: { onClick: () => void; selected?: boolean; children: React.ReactNode } ) {
    const [hover, setHover] = useState( false );
    const on = selected || hover;

    return <button
        type="button"
        onClick={onClick}
        onMouseEnter={() => setHover( true )}
        onMouseLeave={() => setHover( false )}
        onFocus={() => setHover( true )}
        onBlur={() => setHover( false )}
        className="w-100 text-start d-flex align-items-center gap-3 px-3 py-3"
        style={{
            borderRadius: 12,
            border: on ? "1.5px solid #FC5EB4" : "1px solid #E4E4E4",
            background: on ? "#FFF7FB" : "#fff",
        }}>
        <span
            className="d-inline-flex align-items-center justify-content-center flex-shrink-0"
            style={{
                width: 18,
                height: 18,
                borderRadius: "50%",
                border: `2px solid ${on ? "#FC5EB4" : "#CFCFCF"}`,
                background: "#fff",
            }}>
            {on && <span style={{ width: 8, height: 8, borderRadius: "50%", background: "#FC5EB4" }} />}
        </span>
        {children}
    </button>;
}
